import { render, staticRenderFns } from "./CategoryIcon.vue?vue&type=template&id=3d24291c&scoped=true&"
import script from "./CategoryIcon.vue?vue&type=script&lang=js&"
export * from "./CategoryIcon.vue?vue&type=script&lang=js&"
import style0 from "./CategoryIcon.vue?vue&type=style&index=0&id=3d24291c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24291c",
  null
  
)

export default component.exports